export class FilterServiceError extends Error {
}
